import { useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { ChatBotAvatar } from 'components/chats/ChatBotAvatar'

export const BotTyping = () => {
  const botMsgBackgroundColor = 'var(--bot-msg-bg)'
  const botMsgColor = 'var(--bot-typing-dot)'
  const botTyping = useSelector(messagesSelectors.botTyping)

  return (
    <>
      {botTyping ? (
        <div className="tw-flex tw-space-x-1 tw-mt-[12px]">
          <ChatBotAvatar visible={true} />
          <div
            className={`tw-flex tw-w-fit tw-space-x-2 tw-self-start tw-break-words tw-rounded-tl-[20px] tw-rounded-br-[25px] tw-rounded-tr-[20px] tw-rounded-bl-[5px] tw-px-5 tw-py-3 tw-text-sm tw-text-white`}
            style={{ backgroundColor: botMsgBackgroundColor }}
          >
            <div
              className="tw-animation-delay-32 tw-h-2 tw-w-2 tw-animate-bounce tw-rounded-full tw-p-1"
              style={{ backgroundColor: botMsgColor }}
            />
            <div
              className="tw-animation-delay-16 tw-h-2 tw-w-2 tw-animate-bounce tw-rounded-full tw-p-1"
              style={{ backgroundColor: botMsgColor }}
            />
            <div
              className="tw-h-2 tw-w-2 tw-animate-bounce tw-rounded-full tw-p-1"
              style={{ backgroundColor: botMsgColor }}
            />
          </div>
        </div>
      ) : null}
    </>
  )
}
